export const ADD_SUNGLASSES = 'ADD_SUNGLASSES';
export const SUNGLASSES_LOADING = 'SUNGLASSES_LOADING';
export const SUNGLASSES_FAILED = 'SUNGLASSES_FAILED';

export const ADD_CLOTHES = 'ADD_CLOTHES';
export const CLOTHES_LOADING = 'CLOTHES_LOADING';
export const CLOTHES_FAILED = 'CLOTHES_FAILED';

export const ADD_ORDERS = 'ADD_ORDERS';
export const ADD_ORDER = 'ADD_ORDER';
export const ORDERS_FAILED = 'ORDERS_FAILED';
export const RESET_ORDERS = 'RESET_ORDERS';

export const ADD_PRODREQ = 'ADD_PRODREQ';
export const PRODREQ_LOADING = 'PRODREQ_LOADING';
export const PRODREQ_FAILED = 'PRODREQ_FAILED';

export const TOGGLE_CART_PANEL = "TOGGLE_CART_PANEL";

export const ADD_VOUCHERS = 'ADD_VOUCHERS';
export const VOUCHER_LOADING = 'VOUCHER_LOADING';
export const VOUCHER_FAILED = 'VOUCHER_FAILED';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';